import {Component, Input, OnChanges, SimpleChanges, ViewChild, Output, EventEmitter} from '@angular/core';
import { Router } from '@angular/router';
import { PageNotificationService, MenuNavigationService, ShareDataService, LoginService } from '@signature-it/ngx-generic/services';
import { IUser } from '@signature-it/ngx-generic/interfaces';
import { MobileLinksDTO } from '@signature-it/ngx-generic/models';

declare let _: any;

@Component({
    selector: 'dropdown-user-menu',
    templateUrl: './dropdown-menu.html',
    styleUrls: ['./dropdown-menu.scss'],
    standalone: false
})
export class DropdownUserMenuComponentGeneric implements OnChanges {
    @Input() user: IUser;
    @Input()  account: MobileLinksDTO[];
    menuList: Array<any> = [];
    @ViewChild('menu', {static: true}) menu;
    @Output() onMenuClick = new EventEmitter();

    constructor(protected loginService: LoginService,
                protected notifySvc: PageNotificationService,
                protected menuSvc: MenuNavigationService,
                protected router: Router,
                public shareDataService: ShareDataService) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!_.isEmpty(changes['user'].currentValue)) {
            const userNavigation = this.menuSvc.getUserNavigation(this.user);
            this.menuList = this.isMobileMode() ? (this.account || userNavigation) : userNavigation;
        }
    }

    logout() {
        this.loginService.logout().subscribe(
            res => {
                // clear storage data and redirect to given url
                sessionStorage.clear();
                this.router.navigate([_.has(res, 'redirect_url') ? res['redirect_url'] : "/"]).then( (e) => location.reload());
                location.reload();
            },
            err => this.notifySvc.set(err).show()
        );
    }

    isMobileMode(): boolean {
        return document.documentElement.clientWidth	<= 992;
    }

    isExternalLink(link) {
        return /^https?:\/\//i.test(link);
    }

    sidebarClick(link){
        event.preventDefault();
        this.onMenuClick.next(true);
        this.router.navigate([link]);
    }
}
